import {Component} from '@angular/core';
import { navItems } from '../../_nav';

@Component({
  selector: 'app-home',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {
  public sidebarMinimized = false;
  public navItems = navItems;

  logininfo: any = {};

  constructor(
  ) { 
    this.logininfo = JSON.parse(localStorage.getItem('myinfo'));
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  logout() {
    localStorage.removeItem('myinfo');
    window.location.href = "index.html";
  }

}
